import Vue from 'vue';
import Vuex from 'vuex';
// Vuex
Vue.use(Vuex);
export var store = new Vuex.Store({
    state: {
        tab: localStorage.tab || "",
    },
    mutations: {
        tab: function (state, n) {
            state.tab = n;
        },
    },
});
